import React from 'react'

function ExpensesDistribution({ expensesByEachUser }) {
    const totalAmount = expensesByEachUser.reduce((total, userExpense) => total + userExpense.total, 0)

    return (
        <div className='d-flex mb-3'>
            {expensesByEachUser.map((userExpense) => {
                const proportion = (userExpense.total / totalAmount) * 100
                return (
                    <div
                        key={userExpense.user.id}
                        className=' text-muted d-flex flex-column align-items-center justify-content-center'
                        style={{
                            backgroundColor: 'lightblue',
                            width: `${proportion}%`,
                            boxSizing: 'border-box',
                            margin: '0.1rem',
                            padding: '0.5rem',
                            fontSize: '0.8rem',
                            borderRadius: '0.3rem',
                        }}
                    >
                        <p className='fw-bold'>{proportion.toFixed(0)}%</p>
                        <p className='fw-bold'>
                            {proportion < 10 ? userExpense.user.username.slice(0, 1) :
                                proportion < 30 ? userExpense.user.username.slice(0, 8) :

                                    userExpense.user.username}</p>
                        <p> ₹{userExpense.total}</p>
                    </div>
                )
            })}
        </div>
    )
}

export default ExpensesDistribution
